import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CreateUserDto, UpdateUserDto, UserItem } from '../models/admin-portal.response';
import { commonResponse } from '../models/common.model';
import { Observable } from 'rxjs';
import { UserProfile } from '../models/admin.user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    // eslint-disable-next-line @angular-eslint/prefer-inject
    private readonly http: HttpClient

  ) { }


 // services/quotes.service.ts (or users.service.ts)
createUser(body: CreateUserDto) {
  return this.http.post<commonResponse>(`${environment.base_url}auth/users/`, body);
}
updateUser(id: number, body: UpdateUserDto) {
  return this.http.put<UserItem>(`${environment.base_url}auth/users/${id}/`, body);
}
// Optional: partial update if you need PATCH too
patchUser(id: number, body: UpdateUserDto) {
  return this.http.patch<UserItem>(`${environment.base_url}auth/users/${id}/`, body);
}

deleteUser(id: number) {
  return this.http.delete<commonResponse>(`${environment.base_url}auth/users/${id}/`);
}

getRecievedNotifications(query:string):Observable<any>{
  return this.http.get<any>(`${environment.base_url}notifications?${query}`);
}

readNotification(id:string|number, payload:{is_read:boolean}):Observable<any>{
  return this.http.patch<any>(`${environment.base_url}notifications/${id}/`, payload);
}

downloadDemoUserFile(): Observable<{data:string}> {
  return this.http.get<{data:string}>(`${environment.base_url}get-demo-user-file/`);
}
  getProfile(): Observable<{ data: UserProfile }> {
    return this.http.get<{ data: UserProfile }>(`${environment.base_url}auth/user-edit/`);
  }

  updateProfile(payload: any): Observable<any> {
    return this.http.put(`${environment.base_url}auth/user-edit/`, payload);
  }
}
